(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product"] && !Shopify.designMode) return;
  try {
    const productRecommendationsSection =
  document.querySelector('.product-recommendations');
const productRecommendationsSectionMobile =
  document.querySelector('.product-recommendations-mobile');

if (productRecommendationsSection || productRecommendationsSectionMobile) {
  let loaded = false; 

  const handleIntersection = (entries, observer) => {
    for (const entry of entries) {
      if (!entry.isIntersecting || loaded) continue;
      loaded = true;
      const url =
        entry.target?.dataset?.url ||
        productRecommendationsSection?.dataset?.url ||
        productRecommendationsSectionMobile?.dataset?.url;

      if (!url) {
        console.warn('Missing data-url for recommendations fetch.');
        observer.disconnect();
        return;
      }

      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;

          const recommendations = html.querySelector('.product-recommendations');
          const recommendationsMobile = html.querySelector('.product-recommendations-mobile');

          if (recommendations && recommendations.innerHTML.trim()) {
            productRecommendationsSection && (productRecommendationsSection.innerHTML = recommendations.innerHTML);
          }
          if (recommendationsMobile && recommendationsMobile.innerHTML.trim()) {
            productRecommendationsSectionMobile && (productRecommendationsSectionMobile.innerHTML = recommendationsMobile.innerHTML);
          }
        })
        .catch(console.error)
        .finally(() => observer.disconnect()); // stop observing both
    }
  };

  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px 200px 0px',
    threshold: 0
  });

  if (productRecommendationsSection) observer.observe(productRecommendationsSection);
  if (productRecommendationsSectionMobile) observer.observe(productRecommendationsSectionMobile);
}
  } catch(e) { console.error(e); }
})();

})();
